function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "0facd2e8-e5a9-4b30-880c-e91816e55363",
  d: "M112.22 74.57c8.32-10 19.77-27.13 19.78-41.75C132 17.17 120.2 4 104 4S76 16.7 76 32.35C76 54.2 104 84 104 84s6.22-7 8.22-9.43z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 116V24l52-12v92L4 116zM128.59 18.85L156 12v92l-52 12-48-12V12l23.73 5.93"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 32.42,
  r: 12
});

var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "60ac61fb-7d86-4e5f-adf8-a9a2fa4358cb",
    viewBox: "0 0 160 120",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3);
};

export default SvgMap;